
import React, { useRef } from "react";
import { MDBBtn } from 'mdb-react-ui-kit';
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol,
  MDBRipple,
} from "mdb-react-ui-kit";
import "../css/verify.css";
import smartreportBanner from "../images/Technology/final_patient_balance_estimator.webp";
import smartreportBanner1 from "../img/technologies/Infographic/final patient balance estimator.png";
import comunicate from "../img/out of pocket calculator.svg";
import digitalpayment from "../img/shedding cost.svg";
import textreminder from "../img/patient provider.svg";
import textreminder1 from "../img/increase collection.svg";
import "../css/servicesfont.css";
const Home = () => {
  const ref = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);

  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleClick1 = () => {
    ref1.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleClick2 = () => {
    ref2.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleClick3 = () => {
    ref3.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <MDBContainer fluid className="bg-light p-0">
      <div className="container py-5">

        <div class="button-overlay3 mt-4 mb-4 d-none d-lg-block">
          <img
            className=""
            src={smartreportBanner}

            style={{ borderRadius: "10px", height: '600px', paddingLeft: '320px' }}
            alt="Patient Balance estimator"
          />
          <MDBRow>
            <MDBBtn color='link' rippleColor='dark' onClick={handleClick} style={{ fontSize: '12px', color: 'white', fontFamily: 'Alegreya Sans', backgroundColor: 'transparent', height: '260px' }} className="button-overlay3">
            </MDBBtn>
            <MDBBtn color='link' rippleColor='dark' onClick={handleClick1} style={{
              fontSize: '12px', color: 'white', width: '150px',
              left: '60%', fontFamily: 'Alegreya Sans', backgroundColor: 'transparent', height: '260px'
            }}>

            </MDBBtn>
            <MDBBtn color='link' rippleColor='dark' onClick={handleClick2} style={{ fontSize: '12px', color: 'white', width: '180px', left: '37%', height: '260px', top: '480px', fontFamily: 'Alegreya Sans', backgroundColor: 'transparent' }}>

            </MDBBtn>
            <MDBBtn color='link' rippleColor='dark' onClick={handleClick3} style={{ fontSize: '12px', color: 'white', width: '150px', left: '59%', height: '260px', top: '490px', fontFamily: 'Alegreya Sans', backgroundColor: 'transparent' }}>

            </MDBBtn>
          </MDBRow>
        </div>

        <div class="button-overlay3 mt-4 mb-4 d-lg-none">
          <img
            className=""
            src={smartreportBanner1}
            style={{ borderRadius: "10px", width: '100%' }}
            alt="Patient Balance estimator"
          />
        </div>

        <div ref={ref} className="card mt-4">
          <div className="row">
            <div className="col-lg-12 mb-5 p-4 d-md-none">
              <div className="row">
                <div class="col-md-8 " style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Out Of Pocket Calculator</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: 'Alegreya Sans', fontWeight: '500' }}>
                    MDBill calculates the out-of-pocket cost for individual patients based on their individual insurance contracts.
                     You can auto-calculate your contract allowable rates across all CPT and HCPCS codes. With accurate estimates at
                      the time of visit, you can provide your patients with the cost transparency they now demand. 
                      It’s much easier to request payment when patients can see what they owe. Collecting patients out of pocket 
                      expenses at the time of visit helps decrease the risk of bad debt and increase in cash flow.
                  </p>
                </div>
                <div class="col-md-4 text-center mt-4">
                  <img src={comunicate} className="img-fluid" width={350} height={250} alt="Best medical billing solution" />
                </div>

              </div>
            </div>
            <div className="col-lg-12 mb-5 p-4 d-none d-md-block">
              <div className="row">
                <div class="col-md-4 text-center mt-4 ">
                  <img src={comunicate} className="img-fluid" width={350} height={250} alt="Best medical billing solution" />
                </div>

                <div class="col-md-8 " style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Out Of Pocket Calculator</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: 'Alegreya Sans', fontWeight: '500',textAlign: 'justify'  }}>
                  <b>  <a
                            href="https://mdbill.io/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                            MDBill’s
                        </a>  Out-of-Pocket Calculator </b>helps healthcare providers calculate individual patient costs based on specific insurance contracts, 
                   offering real-time transparency that today’s patients expect. This tool auto-calculates contract allowable rates across all CPT and HCPCS codes, 
                   delivering accurate estimates at the time of visit. By clearly showing patients what they owe, it becomes much easier to request and collect payments 
                   during appointments. This not only enhances 
                   
 <a
                            href="https://acerhealth.com/services/revenue-cycle-management"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              revenue cycle management
                        </a>  
                   but also supports <b>medical billing services,</b> reduces the risk of bad debt, and 
                   improves cash flow—strengthening your <b>medical billing outsourcing </b>and compliance efforts while helping your practice operate more efficiently.       </p>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div ref={ref1} className="card p-4 mt-4">
          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Shedding Costs on Statements
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: 'Alegreya Sans', fontWeight: '500',textAlign: 'justify'}}>
                Improve cash flow by shedding the costs associated with traditional patient payment methods—eliminating paper statements, collection calls, and 
                third-party agency commissions. With <b> <a
                            href="https://mdbill.io/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                            MDBill’s
                        </a> technology,</b> you can generate customized patient letters that include patient-specific estimates 
                along with current and past balances, offering clear communication and cost transparency. This approach helps reduce statement costs, increase
                 operational efficiency, and shorten the time it takes to collect payments. By streamlining these processes, your practice can strengthen <b> revenue
                  cycle management,</b> support <b>medical billing services,</b> and enhance the performance of your medical billing outsourcing strategies while minimizing
                   administrative burden.             </p>
                </div>
                <div class="col-md-4 text-center ">
                  <img src={digitalpayment} className="img-fluid" width={350} height={250} alt="Shedding cost" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref={ref2} className="card p-4 mt-4">
          <div className="row">
           
            <div className="col-lg-12 mb-5 d-none d-md-block">
              <div className="row">
                <div class="col-md-4 text-center ">
                  <img src={textreminder} className="img-fluid" width={350} height={250} alt="Patient healthcare consulting service" />
                </div>
                <div class="col-md-8 " style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Patient-Provider Relationship</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: 'Alegreya Sans', fontWeight: '500' ,textAlign: 'justify'}}>
                   Patient satisfaction is at the heart of the healthcare business, and providing transparency throughout the billing process 
                     helps strengthen the patient-provider relationship. Tools like <b> <a
                            href="https://mdbill.io/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                            MDBill’s
                        </a> Patient Balance Estimator </b>deliver the pricing clarity 
                     patients demand, enhancing trust and communication while supporting medical billing services, revenue cycle management, 
                     and medical billing compliance services. This transparency not only 
                     
 <a
                            href="https://acerhealth.com/blogs/what-billing-means-for-patients"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
               improves patient satisfaction
                        </a>  
                     but also boosts your revenue
                      stream by encouraging timely payments and reducing billing-related confusion—ultimately helping your practice thrive in today’s 
                      healthcare environment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={ref3} className="card p-4 mt-4">
          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">

                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Increase Collection</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: 'Alegreya Sans', fontWeight: '500',textAlign: 'justify' }}>
                   Showing patients exactly what they owe not only sets clear payment expectations but also creates an immediate opportunity 
                   to collect payments while they are still in the office. This proactive approach helps avoid the need to chase balances later
                    by enabling your front desk team to begin closing them at the point of service. By supporting faster collections, this process 
                    strengthens <b>revenue cycle management, </b>enhances <b>medical billing services,</b> and improves cash flow—reducing administrative burden
                     and boosting the efficiency of your 
                      <a
                            href="https://acerhealth.com/services/medical-billing-and-credentialing"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                medical billing outsourcing 
                        </a>  
                  strategy.
                  </p>
                </div>
                <div class="col-md-4 text-center ">
                  <img src={textreminder1} className="img-fluid" width={350} height={250} alt="Increase collection" />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
};

export default Home;
